import { render, staticRenderFns } from "./ModalAddClient.vue?vue&type=template&id=30b482ec&scoped=true"
import script from "./ModalAddClient.vue?vue&type=script&lang=js"
export * from "./ModalAddClient.vue?vue&type=script&lang=js"
import style0 from "./ModalAddClient.vue?vue&type=style&index=0&id=30b482ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b482ec",
  null
  
)

export default component.exports